import api from '@/apis/di/inventoryCategoryAPI.js';
import { usefilterActionCombo } from './filterActionCombo.js';
import { getCurrentInstance } from 'vue';

// Combo grid Loại CCDC
export const useToolTypeComboGrid = (comboboxDataRemote, comboboxLoadData) => {
  const { proxy } = getCurrentInstance();
  const { extendFilter } = usefilterActionCombo();
  // func call api lấy dữ liệu combo
  const onToolTypeComboboxLoadData = (payload, row, column, custom) => {
    payload.sort = 'inventory_category_code';
    let ors = [{ Field: 'inactive', Operator: 'NULL' }];
    let ors1 = [{ Field: 'is_tool', Operator: '=' }];
    let extend = [
      { Field: 'inactive', Value: false, Ors: ors },
      { Field: 'is_tool', Value: 1, Ors: ors1 },
    ];
    // payload.filter = {'field':'is_tool','operator':'=','value':true};
    payload.filter = extendFilter(payload.filter, extend);

    comboboxLoadData(payload, api, comboboxDataRemote, column.dataField, custom.callBackFn);
  };

  // config columns combo
  const toolTypeComboConfig = {
    data: comboboxDataRemote,
    columns: [
      {
        title: 'Mã loại CCDC',
        dataField: 'inventory_category_code',
        width: 120,
        filterOperator: proxy.$ms.constant.FilterOperator.StartsWith,
      },
      {
        title: 'Tên loại CCDC',
        dataField: 'inventory_category_name',
        filterOperator: proxy.$ms.constant.FilterOperator.Contains,
        width: 480,
      },
    ],
    displayField: 'inventory_category_code',
    valueField: 'inventory_category_id',
    queryMode: 'remote',
    dropdownWidth: 600,
    comboboxLoadData: onToolTypeComboboxLoadData,
  };

  // Sự kiện load combo trên grid
  return {
    toolTypeComboConfig,
    onToolTypeComboboxLoadData, // trả về thêm để dùng chung cho cả combo không thuộc grid
  };
};
